import Reading from './Reading'

export default class ReadingHeartRate extends Reading {

	constructor (data) {
		super(data)
	}
}



// WEBPACK FOOTER //
// ./src/classes/ReadingHeartRate.js